// REACT IMPORTS
import React from "react";

// ICONS IMPORTS
import { CloseIcon } from "icons/payments/CloseIcon";
import { CircleTickIcon } from "icons/success/CircleTickIcon";

// UTILS IMPORTS
import { useTid } from "utils/testid";

// PROPS TYPES
interface SuccessScreenProps {
  onCloseClick: any;
  title: string;
  content: any;
  /** Accessible name for the close control, e.g. "Close card form". */
  closeLabel?: string;
}

/* ------------------------------------- SUCCESS SCREEN ------------------------------------- */

const SuccessScreen = (props: SuccessScreenProps) => {
  const { onCloseClick, title, content, closeLabel = "Close" } = props;
  const tid = useTid();
  return (
    <div className="bg-bgPrimary h-full animate__animated animate__fadeIn">
      <div className="px-10 py-5 bg-bgPrimary flex items-center justify-end">
        <div
          role="button"
          tabIndex={0}
          aria-label={closeLabel}
          data-testid={tid("success-screen-close-button")}
          onClick={onCloseClick}
          // This is the only way out of the success screen: the drawer fills
          // the viewport on a phone, so there is no backdrop to tap and no
          // Escape key to press. A div with role="button" takes focus but does
          // not fire click on Enter/Space, so those are wired up by hand.
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              onCloseClick(event);
            }
          }}
          className="cursor-pointer p-2 rounded-full hover:!bg-bgSecondary"
        >
          <CloseIcon aria-hidden="true" />
        </div>
      </div>
      <div className="px-[45px] pt-[180px] flex flex-col items-center gap-10">
        <CircleTickIcon />
        <div className="flex flex-col items-center gap-4">
          <p className="text-center text-txtPrimary font-medium text-2xl leading-normal">
            {title}
          </p>
          <p className="text-center text-txtParagraph text-base leading-normal break-words">
            {content}
          </p>
        </div>
      </div>
    </div>
  );
};

export default SuccessScreen;
